import React, { useEffect } from 'react';
import { CircularProgress, Backdrop } from "@mui/material";
import { getisEmp, getOrgType } from '../../../utils/Token';

export default function PaymentSuccessForTraining() {

    useEffect(() => {
        //alert(window.parent.location);
        if (getisEmp() != "true"){
            window.top.location.href = "/EmployeesList";
        }else{
             window.top.location.href = "/EmployeeQuizzes";
        }
    }, []);
    return (
        <div>
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={true}
            >
                <CircularProgress color="inherit" />
            </Backdrop></div>
    )
}
